
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {
  RequirementsClient,DuplicationReasonModel, DuplicationReasonRequirementViewModel
} from "@/api-client";
import RequirementSummary from "../RequirementSummary";

@Component({
})
export default class DuplicationReasonRequirementSummary extends RequirementSummary {
  
  @Prop({required: true})
  requirement!: DuplicationReasonRequirementViewModel;

  chosenReason: DuplicationReasonModel | null = null;

  async created() {
    if (this.requirementValue) {
      this.chosenReason = (await new RequirementsClient().chosenDuplicationReason(this.application.id, this.requirement.id));
    }
  }
}
